export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_RESPONSE = "GET_CATEGORIES_RESPONSE";

export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST";

export const EDIT_CATEGORY_REQUEST = "EDIT_CATEGORY_REQUEST";

export const PATCH_CATEGORY_TOGGLE_REQUEST = "PATCH_CATEGORY_TOGGLE_REQUEST";

export const GET_CATEGORY_DETAILS_REQUEST = "GET_CATEGORY_DETAILS_REQUEST";
export const GET_CATEGORY_DETAILS_RESPONSE = "GET_CATEGORY_DETAILS_RESPONSE";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
